export const getFields = (type) => {
  switch (type) {
  case 'noti-user':
    return [
      {
        key: 'name',
        thClass: 'settings-notifications__block-body--name',
        tdClass: 'settings-notifications__block-body--row-name',
      },
      {
        key: 'toggle',
        thClass: 'settings-notifications__block-body--status',
      },
      {
        key: 'view-user',
        thClass: 'settings-notifications__block-body--actions',
        tdClass: 'settings-notifications__block-body--row-actions',
      },
    ];

  case 'noti-staff':
    return [
      {
        key: 'name',
        thClass: 'settings-notifications__block-body--name',
        tdClass: 'settings-notifications__block-body--row-name',
      },
      {
        key: 'view-staff',
        thClass: 'settings-notifications__block-body--actions',
        tdClass: 'settings-notifications__block-body--row-actions',
      },
    ];

  case 'staff':
    return [
      {
        key: 'email',
        thClass: 'settings-notifications__block-body--email',
        tdClass: 'settings-notifications__block-body--row-email',
      },
      {
        key: 'notification_counter_title',
        thClass: 'settings-notifications__block-body--count',
        tdClass: 'settings-notifications__block-body--row-count',
      },
      {
        key: 'edit',
        thClass: 'settings-notifications__block-body--actions',
        tdClass: 'settings-notifications__block-body--row-actions',
      },
    ];

  default:
    return [];
  }
};

export const STATUS_REQUEST_INTERVAL = 2000;
